import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import aboutImage from '../assets/imgs/about3.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LoadingButton from './utils/Loading';
import LoadingAction from './utils/LoadingAction';
import { toast } from 'sonner';

const About = () => {
  const [resume, setResume] = useState(false);
  const location = useLocation();

  const handleCVClick = () => {
    LoadingAction(setResume, () => {
        const link = document.createElement("a");
        link.href = "/certificates/Tehzeeb_Jahan_MERN_Developer.pdf";
        link.download = "Tehzeeb_Jahan_MERN_Developer.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Resume downloaded successfully!");
      }
    );
  };

  useEffect(() => {
    if(location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } 
    }
  }, [location]);

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

    return (
    <section className="section" id="about">
      <div className="container text-center">
        <div className="about">
          <div className="about-img-holder"  data-aos="fade-right">
            <img
              src={aboutImage}
              className="about-img"
              alt="Tehzeeb Jahan"
            />
          </div>
          <div className="about-caption"  data-aos="fade-left">
            <p className="section-subtitle">Who Am I ?</p>
            <h2 className="section-title mb-3">About Me</h2>
            <p>
            <b>Full-Stack MERN Developer</b> with hands-on experience in building responsive, scalable, and user-friendly
            web applications using <b>React.js, Node.js, Express.js, MongoDB, and MySQL. </b> 
            I enjoy turning ideas into real-world solutions with clean code, secure APIs, and modern UI.<br/>
            Experienced with <b>REST APIs, JWT Authentication, Cloudinary, and Razorpay integration. </b> 
            I'm currently completing my <b>B.Tech in Computer Science from SGSITS, Ujjain</b>, and 
            I'm open to <b>freelance projects, internships, and full-time opportunities.</b>
            </p>
            <LoadingButton 
              isLoading={resume}
              onClick={handleCVClick}
              className="rounded-pill btn btn-outline-primary mt-4 shadow"
            >
              Download Resume
            </LoadingButton>
          </div>
        </div>
      </div>
    </section>

    );
}

export default About;